import { css, html } from 'lit'
import { customElement } from 'lit/decorators.js'
import './skeleton'
import { SkeletonPreset } from './skeleton-preset'

/** Renders `count` stacked text-line skeletons; the last line is narrower to mimic a natural paragraph ending. */
@customElement('schmancy-skeleton-text')
export class SchmancySkeletonText extends SkeletonPreset {
	static styles = [
		css`
			:host {
				display: flex;
				flex-direction: column;
				gap: 0.5rem;
			}
		`,
	]

	render() {
		return html`${Array.from(
			{ length: this.count },
			(_, i) =>
				html`<schmancy-skeleton
					shape="text"
					class="${i === this.count - 1 ? 'w-[55%]' : 'w-full'}"
				></schmancy-skeleton>`,
		)}`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-skeleton-text': SchmancySkeletonText
	}
}
